export default function getAPIEndpoint() {
  if (window.ipcRenderer) {
    return window.ipcRenderer.sendSync('get-api-endpoint')
  } else {
    return process.env.VUE_APP_API_ENDPOINT
  }
}

export function getOpenIdConnectEndpoint() {
  return process.env.VUE_APP_OAUTH_OPENID_CONNECT_URL
}
